import * as React from "react";

import { useTileTexts } from "Store/texts/hooks";
import { useLocation } from "react-router";
import { Multiplexer } from "./components/Multiplexer";

export const UnexpectedState = (): React.ReactElement => {
  const location = useLocation();
  const [{ checkPriceProductIntroTile: texts }, lang] = useTileTexts();

  const status = new URLSearchParams(location.search).get("status");

  return (
    <Multiplexer
      status={Number.parseInt(status ?? "-1")}
      texts={texts}
      lang={lang}
    />
  );
};
